import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEmpresa } from "../../context/EmpresaContext";
import { getEmpresaBrand, loginVendedor } from "../../services/sininApi";
import sininLogo from "../../assets/sinin-logo.svg";

export default function LoginVendedor() {
  const { empresaId } = useParams();
  const empresaSlug = String(empresaId || "").trim().toUpperCase();
  const navigate = useNavigate();
  const { setEmpresa } = useEmpresa();
  const [dni, setDni] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [empresaConfig, setEmpresaConfig] = useState(null);

  useEffect(() => {
    if (!empresaId) navigate("/ADMIN", { replace: true });
    else getEmpresaBrand(String(empresaId).toLowerCase())
      .then(res => setEmpresaConfig(res?.empresa || null))
      .catch(() => setEmpresaConfig(null));
  }, [empresaId, navigate]);

  const handleLogin = async () => {
    setError("");
    if (!dni || !password) return setError("Completá DNI y contraseña.");
    setLoading(true);
    try {
      const data = await loginVendedor(empresaSlug, dni.trim(), password);
      if (data.error) {
        setError(data.error);
        return;
      }
      localStorage.setItem("sinin_token", data.token || "");
      setEmpresa({
        empresaId: data.empresaId,
        role: data.role,
        loginType: data.loginType || "2",
        nombre: data.nombre || data.empresaId,
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        dni: data.dni,
        eventos: data.eventos || [],
        membresias: data.membresias || [],
        colorTicket: data.colorTicket || "#dfa66b",
        colorFondo: data.colorFondo || "#1a1a1a",
        colorFuente: data.colorFuente || "#ffffff",
        colorDark: data.colorDark || "#333333",
        logoKey: data.logoKey || "",
        logoUrl: empresaConfig?.logoUrl || data.logoUrl || "",
      });
      navigate("/vendedor/eventos");
    } catch {
      setError("Error de conexión. Intentá de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const handleKey = event => {
    if (event.key === "Enter") handleLogin();
  };

  return (
    <div style={{ ...styles.page, ...(empresaConfig ? brandedPage(empresaConfig) : {}) }}>
      <div style={{ ...styles.card, color: empresaConfig?.colorFuente || "#fff" }}>
        <img src={empresaConfig?.logoUrl || sininLogo} alt={empresaConfig?.nombre || "SININ"} style={styles.companyLogo} />
        <p style={{ ...styles.sub, color: empresaConfig?.colorFuente || "rgba(255,255,255,.78)" }}>Acceso de vendedor · {empresaConfig?.nombre || empresaSlug}</p>
        <label style={{ ...styles.label, color: empresaConfig?.colorFuente || "#e9ffff" }}>DNI</label>
        <input style={styles.input} value={dni} onChange={e => setDni(e.target.value)} onKeyDown={handleKey} placeholder="12345678" />
        <label style={{ ...styles.label, color: empresaConfig?.colorFuente || "#e9ffff" }}>Contraseña</label>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input style={{ ...styles.input, flex: 1 }} type={showPass ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} onKeyDown={handleKey} />
          <button type="button" aria-label="Mostrar contraseña" style={styles.eye} onClick={() => setShowPass(value => !value)}>{showPass ? "🙈" : "👁️"}</button>
        </div>
        {error && <p style={styles.error}>{error}</p>}
        <button style={{ ...styles.btn, background: empresaConfig?.colorTicket || styles.btn.background, color: empresaConfig?.colorFuente || "#f4fffe", opacity: loading ? 0.7 : 1 }} onClick={handleLogin} disabled={loading}>
          {loading ? "INGRESANDO..." : "INGRESAR"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: { background: "radial-gradient(circle at 16% 12%, rgba(37,244,223,.55), transparent 30%), radial-gradient(circle at 84% 86%, rgba(70,130,255,.24), transparent 34%), linear-gradient(135deg, #071416 0%, #05080a 58%, #10151a 100%)", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, boxSizing: "border-box" },
  card: { background: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.22)", borderRadius: 28, padding: 28, width: "100%", maxWidth: 390, boxShadow: "0 24px 70px rgba(0,0,0,.45)", backdropFilter: "blur(18px)" },
  logoImg: { display: "block", width: 220, maxWidth: "100%", margin: "0 auto 10px" },
  companyLogo: { display: "block", width: 190, height: 105, objectFit: "contain", maxWidth: "100%", margin: "0 auto 10px", background: "transparent" },
  sub: { textAlign: "center", color: "rgba(255,255,255,.78)", fontSize: 13, marginBottom: 24, letterSpacing: 1, textTransform: "uppercase" },
  label: { display: "block", fontWeight: "900", fontSize: 12, marginTop: 14, marginBottom: 6, color: "#e9ffff", letterSpacing: 1, textTransform: "uppercase" },
  input: { padding: "13px 15px", borderRadius: 18, width: "100%", border: "1px solid rgba(255,255,255,.34)", background: "rgba(255,255,255,.9)", color: "#05080a", fontSize: 15, boxSizing: "border-box", outline: "none" },
  eye: { marginLeft: 10, cursor: "pointer", fontSize: 18, width: 42, height: 42, borderRadius: "50%", display: "grid", placeItems: "center", background: "rgba(255,255,255,.16)", border: "1px solid rgba(255,255,255,.22)" },
  btn: { background: "linear-gradient(145deg, rgba(207,255,250,.62) 0%, rgba(37,244,223,.34) 46%, rgba(14,145,137,.28) 100%)", color: "#f4fffe", padding: 15, width: "100%", borderRadius: 25, border: "1px solid rgba(218,255,251,.72)", marginTop: 24, cursor: "pointer", fontWeight: "900", fontSize: 15, letterSpacing: 1, boxShadow: "inset 0 2px 1px rgba(255,255,255,.62), 0 7px 0 rgba(6,91,86,.7), 0 15px 30px rgba(37,244,223,.3)" },
  error: { color: "#fff", background: "rgba(255,48,91,.86)", borderRadius: 16, padding: 10, marginTop: 12, textAlign: "center", fontSize: 13, fontWeight: 800 },
};

const brandedPage = empresa => ({
  background: `radial-gradient(circle at 15% 12%, ${empresa.colorTicket || "#25f4df"}88, transparent 34%), linear-gradient(145deg, ${empresa.colorFondo || "#1a1a1a"}, ${empresa.colorDark || empresa.colorFondo || "#111"})`,
});
